<template>
  <div class="activityCompletion hintDialog flexcenter" :class="isHintHosoku? 'hintHosoku' : ''">
    <transition>
      <div class="activity flexcenter">
        <div class="activityContent">
          <div class="hintBox flexcenter">
            <div class="item">
              <p v-if="isHintHosoku">{{ hintText }}</p>
              <p v-else>ヒント：{{ hintText }}<br><br>ドラッグ アンド ドロップの操作は不要です。</p>
            </div>
          </div>
        </div>
        <div class="activityResetFooter">
          <div class="buttons flexbetween">
            <button type=button v-on:click="clickButton()" class="btn">{{ buttonText }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'HintDialog',
  props: {
    hintText: String,
    isHintHosoku: Boolean
  },
  data () {
    return {
      buttonText: '続行'
    }
  },
  mixins: [
    common,
  ],
  methods: {
    clickButton: function() {
      // 閉じる
      this.$store.dispatch('setShowHintDialog', false);
    }
  },
  created: function() {
    this.log("HintDialog start created")
  },
  mounted: function() {
    this.log("HintDialog start mounted")
    this.setBodyStylePosition(true)
    if (this.isHintHosoku) {
      // 補足表示
      this.buttonText = 'OK'
    }
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// HintDialog.vue?328f7a64